var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8 1.3C19.8 1.10537 19.7484 0.914223 19.6505 0.746054C19.5525 0.577885 19.4117 0.43872 19.2423 0.342762C19.073 0.246804 18.8813 0.197488 18.6867 0.199849C18.492 0.20221 18.3015 0.256162 18.1346 0.356199L7.3964 6.7956H3.3C2.42479 6.7956 1.58542 7.14328 0.966548 7.76215C0.347678 8.38102 0 9.22038 0 10.0956L0 18.889C0 20.715 1.4784 22.189 3.3 22.189H7.3964L18.1324 28.6262C18.2994 28.7268 18.4901 28.7812 18.6851 28.7839C18.88 28.7865 19.0721 28.7373 19.2418 28.6413C19.4115 28.5452 19.5526 28.4058 19.6506 28.2374C19.7487 28.0689 19.8003 27.8774 19.8 27.6824V1.3ZM22 11.2V17.8H24.2V11.2H22Z",
    fill: "url(#paint0_linear_368_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_3",
    x1: 12.1,
    y1: 0.199768,
    x2: 12.1,
    y2: 28.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLow);
export default __webpack_public_path__ + "static/media/low.690b63bba6fe030472826be9c05e834e.svg";
export { ForwardRef as ReactComponent };